/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Note } from '../../models/note';

export interface NotesTemplateAddPatientNotes$Params {
  emrpracticeId?: string | null;
}

export function notesTemplateAddPatientNotes(http: HttpClient, rootUrl: string, params?: NotesTemplateAddPatientNotes$Params, context?: HttpContext): Observable<StrictHttpResponse<Note>> {
  const rb = new RequestBuilder(rootUrl, notesTemplateAddPatientNotes.PATH, 'get');
  if (params) {
    rb.query('emrpracticeId', params.emrpracticeId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Note>;
    })
  );
}

notesTemplateAddPatientNotes.PATH = '/notes/addNotes';
